
import { useEffect, useRef } from 'react';
import { useLocalStorageState } from 'ahooks';

export function useCachedState<T>(key: string, defaultValue: T, duration: number =  24 * 60 * 60 * 1000): [T, (value: T) => void, () => void] {
  const [state, setState] = useLocalStorageState<T>(key,  {
    defaultValue,
  },);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    if (duration > 0) {
      timerRef.current = setTimeout(() => {
        localStorage.removeItem(key);
        setState(defaultValue);
      }, duration);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [key, defaultValue, duration, setState]);

  const resetCache = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    localStorage.removeItem(key);
    setState(defaultValue);
  };

  return [state, setState, resetCache];
}

export default useCachedState;
